import React, { useEffect } from 'react';

const useNetwork = () => {
    const [isOnline, setIsOnline] = React.useState(navigator?.onLine);

    const onGettingOnline = () => {
        setIsOnline(true);
    };
    const onGettingOffline = () => {
        setIsOnline(false);
    };

    useEffect(() => {
        window.addEventListener('online', onGettingOnline);
        window.addEventListener('offline', onGettingOffline);
        return () => {
            window.removeEventListener('online', onGettingOnline);
            window.removeEventListener('offline', onGettingOffline);
        };
    }, []);

    return { isOnline };
};

export default useNetwork;